import React from "react"
import { Link } from "gatsby"

const Footer = () => {
  return (
    <footer className="l-footer">
      <div className="p-footerMenu">
        <div className="w-container">
          <ul className="p-footerMenuList" aria-label="メニュー">
            <li className="p-footerMenuItem">
              <Link to="/">HOME</Link>
            </li>
            <li className="p-footerMenuItem">
              <Link to="/about/">ABOUT</Link>
            </li>
            <li className="p-footerMenuItem">
              <Link to="/privacy-policy/">PRIVACY POLICY</Link>
            </li>
            <li className="p-footerMenuItem">
              <Link to="/contact/">CONTACT</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="p-footerCopyright">
        <div className="w-container">
          <p>© フリーランス女子の投資&amp;節税日記 All Rights Reserved</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
